"use client"

import { useState } from "react"
import styled from "styled-components"
import Card from "../ui/Card"
import Tabs from "../ui/Tabs"
import LongShortRatio from "../widgets/LongShortRatio"
import WhaleLiquidations from "../widgets/WhaleLiquidations"
import FundingRate from "../widgets/FundingRate"

const StatsCard = styled(Card)`
  width: 100%;
`

const CardHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${(props) => props.theme.border};
`

const CardTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
`

const CardDescription = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.secondaryText};
`

const CardContent = styled.div`
  padding: 16px;
`

function TradingStats() {
  const [activeTab, setActiveTab] = useState("longshort")

  const tabs = [
    { id: "longshort", label: "Long/Short" },
    { id: "whales", label: "Whales" },
    { id: "funding", label: "Funding" },
  ]

  return (
    <StatsCard>
      <CardHeader>
        <CardTitle>Trading Statistics</CardTitle>
        <CardDescription>Market sentiment and trading data</CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} fullWidth />
        <div style={{ marginTop: "16px" }}>
          {activeTab === "longshort" && <LongShortRatio />}
          {activeTab === "whales" && <WhaleLiquidations />}
          {activeTab === "funding" && <FundingRate />}
        </div>
      </CardContent>
    </StatsCard>
  )
}

export default TradingStats

